import React, { createContext, useContext, ReactNode, useState, useEffect, useCallback } from 'react';
import { kafintech_products } from '../constantes/kafintech-product';

const STORAGE_KEY = 'selected_product';

interface ProductContextType {
  selectedProduct: string;
  changeProduct: (product: string) => void;
  resetProduct: () => void;
  getSelectedProductLabel: () => string;
  isProductSelected: (productValue: string) => boolean;
}

export const ProductContext = createContext<ProductContextType | null>(null);

export function ProductProvider({ children }: { children: ReactNode }) {
  // ✅ Toute la logique est ici, plus besoin de useSelectedProduct
  const [selectedProduct, setSelectedProduct] = useState<string>(() => {
    const saved = localStorage.getItem(STORAGE_KEY);
    return saved || 'all';
  });

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, selectedProduct);
  }, [selectedProduct]);

  const changeProduct = useCallback((productValue: string) => {
    setSelectedProduct(productValue);
  }, []);

  const resetProduct = useCallback(() => {
    setSelectedProduct('all');
  }, []);

  const getSelectedProductLabel = useCallback(() => {
    const product = kafintech_products.find(p => p.value === selectedProduct);
    return product ? product.label : 'Tous les produits';
  }, [selectedProduct]);

  const isProductSelected = useCallback((productValue: string) => {
    return selectedProduct === productValue;
  }, [selectedProduct]);

  const value = {
    selectedProduct,
    changeProduct,
    resetProduct,
    getSelectedProductLabel,
    isProductSelected,
  };

  return (
    <ProductContext.Provider value={value}>
      {children}
    </ProductContext.Provider>
  );
}
